import { EventEmitter } from 'events';

let emitter = new EventEmitter();
emitter.setMaxListeners(50);
if (typeof window !== 'undefined') {
    if (!window.pubsub) {
        window.pubsub = new EventEmitter();
    }
    emitter = window.pubsub;
}
const eventNames = emitter.eventNames.bind(emitter);
const setMaxListeners = emitter.setMaxListeners.bind(emitter);
const getMaxListeners = emitter.getMaxListeners.bind(emitter);
const emit = emitter.emit.bind(emitter);
const addListener = emitter.addListener.bind(emitter);
const on = emitter.on.bind(emitter);
const once = emitter.once.bind(emitter);
const prependListener = emitter.prependListener.bind(emitter);
const prependOnceListener = emitter.prependOnceListener.bind(emitter);
const removeListener = emitter.removeListener.bind(emitter);
const off = emitter.off.bind(emitter);
const removeAllListeners = emitter.removeAllListeners.bind(emitter);
const listeners = emitter.listeners.bind(emitter);
const listenerCount = emitter.listenerCount.bind(emitter);
const rawListeners = emitter.rawListeners.bind(emitter);

export { addListener, emit, eventNames, getMaxListeners, listenerCount, listeners, off, on, once, prependListener, prependOnceListener, rawListeners, removeAllListeners, removeListener, setMaxListeners };
